import MatreshkaArray from './index.js';
import arrayFrom from '../_helpers/arrayfrom.js';
// creates a new Matreshka.Array instance from an array-like or iterable object
export default function from(arrayLike, mapFn, thisArg) {
  // allow to inherit this method by child classes
  var ParentClass = typeof this === 'function' ? this : MatreshkaArray;
  var result = new ParentClass();
  // recreate applies Model and item mediator of the class
  return result.recreate(arrayFrom(arrayLike, mapFn, thisArg), {
    silent: true,
    dontRender: true
  });
}